<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { convertLegacyCartData } from "@/utils/cartDataConverter";

export default {
  name: "app",
  created() {
    // 因 20251017 需求，金牌文字格式需進行轉換，以防購物車含有舊格式，因此需要此轉換工具
    // 將舊格式（text）轉換為新格式（engraving_content）
    const cartData = JSON.parse(localStorage.getItem("cartorder"));
    if (cartData) {
      const convertedData = convertLegacyCartData(cartData);
      localStorage.setItem("cartorder", JSON.stringify(convertedData));
    }
  },
};
</script>

<style lang="scss">
#app {
  font-family: Helvetica, Arial, "PingFang SC", "Microsoft YaHei";
}
.bodyhidden {
  // overflow-y: scroll;
  position: fixed;
  width: 100%;
}
</style>
